var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/action-button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { followAccount, unfollowAccount, blockAccount, unblockAccount, muteAccount, unmuteAccount, authorizeFollowRequest, rejectFollowRequest } from 'soapbox/actions/accounts';
import { openModal } from 'soapbox/actions/modals';
import { Button, HStack, Spinner } from 'soapbox/components/ui';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
const messages = defineMessages({
  block: {
    "id": "account.block",
    "defaultMessage": "Block @{name}"
  },
  blocked: {
    "id": "account.blocked",
    "defaultMessage": "Blocked"
  },
  edit_profile: {
    "id": "account.edit_profile",
    "defaultMessage": "Edit profile"
  },
  follow: {
    "id": "account.follow",
    "defaultMessage": "Follow"
  },
  mute: {
    "id": "account.mute",
    "defaultMessage": "Mute @{name}"
  },
  remote_follow: {
    "id": "account.remote_follow",
    "defaultMessage": "Remote follow"
  },
  requested: {
    "id": "account.requested",
    "defaultMessage": "Click to cancel"
  },
  awaiting_approval: {
    "id": "account.awaiting_approval",
    "defaultMessage": "Awaiting approval"
  },
  unblock: {
    "id": "account.unblock",
    "defaultMessage": "Unblock @{name}"
  },
  unfollow: {
    "id": "account.unfollow",
    "defaultMessage": "Unfollow"
  },
  unmute: {
    "id": "account.unmute",
    "defaultMessage": "Unmute @{name}"
  },
  authorize: {
    "id": "follow_request.authorize",
    "defaultMessage": "Authorize"
  },
  reject: {
    "id": "follow_request.reject",
    "defaultMessage": "Reject"
  }
});
/**
 * Circumstantial action button (usually "Follow") to display on accounts.
 * May say "Unblock" or something else, depending on the relationship and
 * `actionType` prop.
 */
const ActionButton = ({
  account,
  actionType,
  small
}) => {
  const dispatch = useDispatch();
  const features = useFeatures();
  const intl = useIntl();
  const me = useAppSelector(state => state.me);
  const handleFollow = () => {
    if (account.relationship?.following || account.relationship?.requested) {
      dispatch(unfollowAccount(account.id));
    } else {
      dispatch(followAccount(account.id));
    }
  };
  const handleBlock = () => {
    if (account.relationship?.blocking) {
      dispatch(unblockAccount(account.id));
    } else {
      dispatch(blockAccount(account.id));
    }
  };
  const handleMute = () => {
    if (account.relationship?.muting) {
      dispatch(unmuteAccount(account.id));
    } else {
      dispatch(muteAccount(account.id));
    }
  };
  const handleAuthorize = () => {
    dispatch(authorizeFollowRequest(account.id));
  };
  const handleReject = () => {
    dispatch(rejectFollowRequest(account.id));
  };
  const handleRemoteFollow = () => {
    dispatch(openModal('UNAUTHORIZED', {
      action: 'FOLLOW',
      account: account.id,
      ap_id: account.url
    }));
  };
  /** Handles actionType='muting' */
  const mutingAction = () => {
    const isMuted = account.relationship?.muting;
    const messageKey = isMuted ? messages.unmute : messages.mute;
    const text = intl.formatMessage(messageKey, {
      name: account.username
    });
    return /*#__PURE__*/React.createElement(Button, {
      theme: isMuted ? 'danger' : 'secondary',
      size: "sm",
      text: text,
      onClick: handleMute,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 7
      }
    });
  };

  /** Handles actionType='blocking' */
  const blockingAction = () => {
    const isBlocked = account.relationship?.blocking;
    const messageKey = isBlocked ? messages.unblock : messages.block;
    const text = intl.formatMessage(messageKey, {
      name: account.username
    });
    return /*#__PURE__*/React.createElement(Button, {
      theme: isBlocked ? 'danger' : 'secondary',
      size: "sm",
      text: text,
      onClick: handleBlock,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 7
      }
    });
  };
  const followRequestAction = () => {
    if (account.relationship?.followed_by) return null;
    return /*#__PURE__*/React.createElement(HStack, {
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Button, {
      theme: "secondary",
      size: "sm",
      text: intl.formatMessage(messages.authorize),
      onClick: handleAuthorize,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 134,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement(Button, {
      theme: "danger",
      size: "sm",
      text: intl.formatMessage(messages.reject),
      onClick: handleReject,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 9
      }
    }));
  };

  /** Render a remote follow button, depending on features. */
  const renderRemoteFollow = () => {
    // Remote follow through the API.
    if (features.remoteInteractions) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: handleRemoteFollow,
        icon: require('@tabler/icons/plus.svg'),
        text: intl.formatMessage(messages.follow),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155,
          columnNumber: 9
        }
      });
      // Pleroma's classic remote follow form.
    } else if (features.pleromaRemoteFollow) {
      return /*#__PURE__*/React.createElement("form", {
        method: "POST",
        action: "/main/ostatus",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 164,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "nickname",
        value: account.acct,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165,
          columnNumber: 11
        }
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "profile",
        value: "",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 11
        }
      }), /*#__PURE__*/React.createElement(Button, {
        text: intl.formatMessage(messages.remote_follow),
        type: "submit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167,
          columnNumber: 11
        }
      }));
    }
    return null;
  };

  /** Render remote follow if federating, otherwise hide the button. */
  const renderLoggedOut = () => {
    if (features.federating) {
      return renderRemoteFollow();
    }
    return null;
  };
  if (!me) {
    return renderLoggedOut();
  }
  if (me !== account.id) {
    const isFollowing = account.relationship?.following;
    const blockedBy = account.relationship?.blocked_by;
    if (actionType) {
      if (actionType === 'muting') {
        return mutingAction();
      } else if (actionType === 'blocking') {
        return blockingAction();
      } else if (actionType === 'follow_request') {
        return followRequestAction();
      }
    }
    if (!account.relationship) {
      // Wait until the relationship is loaded
      return null;
    } else if (account.relationship?.requested) {
      // Awaiting acceptance
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-1",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 208,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        classNames: "flex gap-1",
        theme: "secondary",
        onClick: handleFollow,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 209,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        withText: false,
        size: 16,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 215,
          columnNumber: 13
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "overflow-hidden text-ellipsis whitespace-nowrap max-w-[110px]",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 216,
          columnNumber: 13
        }
      }, intl.formatMessage(messages.awaiting_approval))));
    } else if (!account.relationship?.blocking && !account.relationship?.muting) {
      // Follow & Unfollow
      return /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        disabled: blockedBy,
        theme: isFollowing ? 'secondary' : 'primary',
        icon: blockedBy ? require('@tabler/icons/ban.svg') : !isFollowing && require('@tabler/icons/plus.svg'),
        onClick: handleFollow,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 225,
          columnNumber: 9
        }
      }, isFollowing ? intl.formatMessage(messages.unfollow) : intl.formatMessage(blockedBy ? messages.blocked : messages.follow));
    } else if (account.relationship?.blocking) {
      // Unblock
      return /*#__PURE__*/React.createElement(Button, {
        theme: "danger",
        size: "sm",
        text: intl.formatMessage(messages.unblock, {
          name: account.username
        }),
        onClick: handleBlock,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 242,
          columnNumber: 9
        }
      });
    }
  } else {
    // Edit profile
    return /*#__PURE__*/React.createElement(Button, {
      theme: "secondary",
      size: "sm",
      text: intl.formatMessage(messages.edit_profile),
      to: "/settings/profile",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253,
        columnNumber: 7
      }
    });
  }
  return null;
};
export default ActionButton;